import React, { createContext } from 'react'
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Skeleton,
} from '@mui/material'
import { useGetStaffBenefits } from '../../api/staff-benefit'
import ErrorMessage from '../shared/component/ErrorMessage'
import { StaffBenefitRow } from './StaffBenefitRow'

const initState = {
  refetch: undefined,
}
export const StaffBenefitContext = createContext(initState)

export const StaffBenefitTable = () => {
  const { data, refetch, isLoading, error } = useGetStaffBenefits()

  const staffBenefits = data?.docs ?? []

  return (
    <StaffBenefitContext.Provider value={{ refetch }}>
      {error ? (
        <ErrorMessage error={error} />
      ) : data?.docs?.length > 0 || isLoading ? (
        <TableContainer component={Paper}>
          <Table aria-label='order table'>
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Name</TableCell>
                <TableCell align='right'>Message</TableCell>
                <TableCell align='right'>Discount</TableCell>
                <TableCell align='center'>Users</TableCell>
                <TableCell align='center'>Redeemed</TableCell>
                <TableCell align='right'>Validity Period</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading
                ? Array(10)
                    .fill('')
                    .map((x, idx) => (
                      <TableRow key={idx}>
                        <TableCell>
                          <Skeleton style={{ width: '100%', marginBottom: 8 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton style={{ width: '100%', marginBottom: 8 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton style={{ width: '100%', marginBottom: 8 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton style={{ width: '100%', marginBottom: 8 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton style={{ width: '100%', marginBottom: 8 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton style={{ width: '100%', marginBottom: 8 }} />
                        </TableCell>
                        <TableCell>
                          <Skeleton style={{ width: '100%', marginBottom: 8 }} />
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    ))
                : staffBenefits.map((row) => {
                    return <StaffBenefitRow row={row} key={row.id} />
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <ErrorMessage empty />
      )}
    </StaffBenefitContext.Provider>
  )
}
